var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.symbol === 'g')?[_vm._v("\n    "+_vm._s(_vm._f("number-format")(Number(_vm.quantityGr),2,true))+" "+_vm._s(_vm.$tc('label.gram', Number(_vm.quantityGr)))+"\n  ")]:[_vm._v("\n    "+_vm._s(_vm._f("number-format")(_vm.amount))+" "+_vm._s(_vm.servingSizeTitle)+" ("+_vm._s(_vm._f("number-format")(Number(_vm.quantityGr),2,true))+"g)\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4033c9df","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/label/nuttrema-stuff-to-eat-quantity.vue
// module id = 3041
// module chunks = 0